import { render } from "./UserBackUpPage.vue?vue&type=template&id=493df736&scoped=true"
import script from "./UserBackUpPage.vue?vue&type=script&lang=js"
export * from "./UserBackUpPage.vue?vue&type=script&lang=js"

import "./UserBackUpPage.vue?vue&type=style&index=0&id=493df736&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-493df736"]])

export default __exports__